import { createContext } from "react";

const ClassRoutineContext = createContext();

export default ClassRoutineContext;